const stringConstants = {
  defaultErrorMessage: 'OOPS! looks like some of our actors are throwing tantrums.',
  retryButton: 'Retry',
};

export default stringConstants;
